import React, { FC, ComponentProps } from 'react'
import cn from 'classnames'
import { Tooltip, Icon } from '../index'
import './index.less'

export interface DashboardCardProps extends Omit<ComponentProps<'div'>, 'onClick'> {
  title?: string
  tipText?: string
  count?: number | string
  countPrefix?: string
  countUnit?: string
  countColor?: string
  icon?: React.ReactNode
  iconColor?: string
  bgColor?: string
  iconShape?: string
  theme: string
  bgGradient?: boolean
}

export const DashboardCard: FC<DashboardCardProps> = ({
  className,
  title,
  tipText,
  count,
  countPrefix,
  countUnit,
  countColor,
  icon,
  iconColor,
  bgColor,
  style,
  theme = 'default',
  iconShape = 'round',
  bgGradient = false,
  ...rest
}) => {
  const cardTheme = {
    'tntd-dashboard-card-default': theme === 'default',
    'tntd-dashboard-card-s1': theme === 's1',
    'tntd-dashboard-card-s2': theme === 's2',
    'tntd-dashboard-card-s3': theme === 's3',
    'tntd-dashboard-card-s4': theme === 's4',
  }

  const hexToRgba = (hexColor: string, alpha: number = 0.5) => {
    // 移除 # 号并提取颜色值
    const hex = hexColor.replace('#', '')

    // 将颜色值拆分成 R、G、B 三个部分
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    // 转换为 RGBA 格式并添加透明度
    const rgba = `rgba(${r}, ${g}, ${b}, ${alpha})`

    return rgba
  }

  // iconStyle
  const iconStyle: any = { background: 'inherit' }
  if (theme === 'default' || theme === 's2') {
    iconStyle.background = iconColor
  }
  if (theme === 's3' || theme === 's4') {
    const rgbaColor = hexToRgba(iconColor || '#59a6e5', 0.2)
    iconStyle.background = rgbaColor
    iconStyle.color = iconColor
  }
  // bgColor
  const bgStyle: any = { background: bgColor }
  if (theme === 's4') {
    const rgbaColor = hexToRgba(bgColor || '#59a6e5', 0.2)
    bgStyle.background = rgbaColor
    bgStyle.borderLeft = `4px solid ${bgColor}`
  }
  if (theme !== 's4' && bgGradient) {
    const rgbaColor = hexToRgba(bgColor || '#59a6e5', 0.8)
    delete bgStyle.background
    bgStyle.backgroundImage = `linear-gradient(to right, ${rgbaColor} ,${bgColor})`
  }

  return (
    <div className={cn(['tntd-dashboard-card', className, { ...cardTheme }])} {...rest}>
      {(theme === 'default' || theme === 's1' || theme === 's3' || theme === 's4') && (
        <div className="main-wrap" style={bgStyle}>
          {icon && (
            <div className={`icon-wrap ${iconShape}`} style={iconStyle}>
              {icon}
              {theme === 's3' && <span className="line"></span>}
            </div>
          )}
          <div className="content-wrap">
            <div className="title">
              <h4>{title}</h4>
              {tipText && (
                <Tooltip title={tipText}>
                  <Icon type="info-circle" theme="filled" />
                </Tooltip>
              )}
            </div>
            <div className="data">
              <span className="num">{count}</span>
            </div>
          </div>
        </div>
      )}
      {theme === 's2' && (
        <div className="main-wrap" style={bgStyle}>
          <div className="title">
            <h4>{title}</h4>
            {tipText && (
              <Tooltip title={tipText}>
                <Icon type="info-circle" theme="filled" />
              </Tooltip>
            )}
          </div>
          <div className="content-wrap">
            {icon && (
              <div className={`icon-wrap ${iconShape}`} style={iconStyle}>
                {icon}
              </div>
            )}
            <div className="data">
              <span className="num">{count}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

DashboardCard.displayName = 'DashboardCard'

export default DashboardCard
